import React, { Component } from 'react';
import axios from "axios"
import AppStore from "../AppStore"
import SignaturePod from "./SignaturePod"
import {observer} from "mobx-react"
import { Redirect } from "react-router-dom";

@observer
export default class Signatures extends Component {
  constructor(props) {
    super(props);
    this.validateBTN = this.validateBTN.bind(this)
    this.setPropPad = this.setPropPad.bind(this)
    this.setExpertPad = this.setExpertPad.bind(this)
    this.setLocPad = this.setLocPad.bind(this)
    this.validateSignatures = this.validateSignatures.bind(this)
    this.state = {
      locPad: "",
      propPad: "",
      expertPad:""
    };
  }
  setPropPad(link){
    this.setState({propPad: link})
  }
  setLocPad(link){
    this.setState({locPad: link})
  }
  validateSignatures(e){
    e.preventDefault()
    axios.post("/api/v1/experts/app/ordremission/sign",{id: AppStore.rdv.id,locataire: this.state.locPad,proprietaire: this.state.propPad,expert: this.state.expertPad}).then((data)=>{
      location.replace("/experts/app/expetise/"+AppStore.rdv.id)
    })
  }
  setExpertPad(link){
    this.setState({expertPad: link})
  }
  validateBTN(){
    if(this.state.locPad.length>0 && this.state.propPad.length > 0 && this.state.expertPad.length > 0){
      return (
        <div>
            <a href="" onClick={this.validateSignatures} className="btn btn-large"><i className="material-icons left">done</i>Enregistrer</a>
        </div>
        )
    }else{
      return(
          <div>
            <p className="red-text">Veuillez signer et valider</p>
          </div>
        )
    }
  }
  render() {
    return (
      <div>
      <div className="row">
        <div className="col s12">
        <iframe width="100%"  height="500px" src={"/experts/app/expetise/ordremission/"+AppStore.rdv.id+".pdf"} frameBorder="0"></iframe>
        </div>
      </div>
      <div className="row">
        <div className="col s4">
        <h2 className="center">Propriétaire</h2>
          <SignaturePod sign={this.setPropPad}/>

        </div>
        <div className="col s4">
        <h2 className="center">Locataire</h2>
          <SignaturePod sign={this.setLocPad}/>

        </div>
        <div className="col s4">
          <h2 className="center">Expert</h2>
          <SignaturePod sign={this.setExpertPad}/>
        </div>

      </div>
      <div className="container">
        <div className="row">
          <div className="col s3 offset-s9">
          {this.validateBTN()}
          </div>
        </div>
      </div>
      </div>
    );
  }
}

